/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ role: NonNullable<unknown> }} Current_Role_As_ValueInputs */

const en_current_role_as_value = /** @type {(inputs: Current_Role_As_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Current role as: ${i?.role}`)
};

const es_current_role_as_value = /** @type {(inputs: Current_Role_As_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rol actual: ${i?.role}`)
};

/**
* | output |
* | --- |
* | "Current role as: {role}" |
*
* @param {Current_Role_As_ValueInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const current_role_as_value = /** @type {((inputs: Current_Role_As_ValueInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Current_Role_As_ValueInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_current_role_as_value(inputs)
	return es_current_role_as_value(inputs)
});